import { Container } from "react-bootstrap";
import parse from "html-react-parser";
import { RootState } from "../reducers";
import { useSelector } from "react-redux";

const PageHowToBuy = () => {
  const textPages = useSelector((state: RootState) => state.shop.textPages);
  return (
    <Container>
       {textPages?.textHowtobuy && parse(textPages.textHowtobuy)}
    </Container>
  );
}
export default PageHowToBuy;
